import store from 'store'

export default {
    namespaced: true, // Torna este módulo com namespace
    state: {
        numeroTarefas: 0,
    },
    mutations: {

        SET_STATE(state, payload) {
            Object.assign(state, {
                ...payload,
            })
        },
    },
    actions: {
        setNumeroTarefas({ commit }, { valor }) {
            commit('SET_STATE', {
                numeroTarefas: valor,
            });
        },
    },
    getters: {
        dados: (state) => state,
    },
}